import React, { PropsWithChildren, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

export const PromiseRejectionHandler: React.FC = ({ children }: PropsWithChildren<any>) => {
  const [hasError, setError] = useState(false);

  const promiseRejectionHandler = (_event: PromiseRejectionEvent) => {
    setError(true);
  };

  useEffect(() => {
    window.addEventListener('unhandledrejection', promiseRejectionHandler);
    return () => {
      window.removeEventListener('unhandledrejection', promiseRejectionHandler);
    };
  }, []);

  useEffect(() => {
    if (hasError) {
      setError(false);
      throw new Error('ErrorWrapper: Unhandled Rejection Error!');
    }
  }, [hasError]);

  return children;
};

interface ErrorWrapperProps {
  redirectElement: React.ReactElement;
}

export const ErrorWrapper: React.FC<ErrorWrapperProps> = (props) => {
  const location = useLocation();
  function ErrorFallback() {
    return props.redirectElement;
  }

  return (
    <ErrorBoundary fallbackRender={ErrorFallback} resetKeys={[location.pathname]}>
      <PromiseRejectionHandler>{props.children}</PromiseRejectionHandler>
    </ErrorBoundary>
  );
};

export function throwWrapper(error: Error, handleError: (error: unknown) => void) {
  handleError(error);
  throw error;
}
